<section class="chart-wrapper">
  <div #barChart></div>
</section>
